<svg width="16" height="16" viewBox="0 0 16 16" fill="none" xmlns="http://www.w3.org/2000/svg">
<path d="M2.5 9.5V2.5H13.5V13.5H5.5V9.5H2.5Z" stroke="currentColor"/>
</svg>
